import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CollaboratorPage } from '~/components/routes/logistics/collaborator-page'
import {
  LogisticsRecordRoute,
  logisticsRecordIdParam,
} from '~/components/routes/logistics/logistics-record-page'
import { LOGISTICS_COLLABORATOR_READ } from '~/components/routes/logistics/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsRecordSearch, recordOriginOf } from '../-record-origin'

export const Route = createFileRoute('/_authenticated/logistics/collaborators/$collaboratorId')({
  staticData: {
    permission: LOGISTICS_COLLABORATOR_READ,
  },
  component: CollaboratorDetailRoute,
  params: {
    parse: z.object({ collaboratorId: logisticsRecordIdParam() }).parse,
  },
  // Mêmes paramètres que la page Logistique : les filtres de la liste suivent l'aller-retour. Et
  // l'écran d'origine (`returnTo`), où ramène le retour de la fiche (LU-181).
  validateSearch: logisticsRecordSearch,
})
withRoutePermissions(Route)

function CollaboratorDetailRoute() {
  const { collaboratorId } = Route.useParams()
  // L'origine reste à la fiche : changer d'onglet ou revenir à la liste ne la reporte pas.
  const { returnTo, ...search } = Route.useSearch()
  const origin = recordOriginOf(returnTo)
  return (
    <LogisticsRecordRoute tab="hr" search={search} permission={LOGISTICS_COLLABORATOR_READ}>
      {(search) => (
        <CollaboratorPage collaboratorId={collaboratorId} search={search} origin={origin} />
      )}
    </LogisticsRecordRoute>
  )
}
